import React from 'react';
import axios from 'axios';
import ReturnProgressbar from './Returnprogressbar';
import ReturnOrderDetailsBlock from './ReturnOrderDetailsBlock';
import ReturnStoreOrderDetailsBlock from './ReturnStoreOrderDetails';
import ReturnNotebyAdmin from './ReturnNoteByAdmin';
import OrderItemDetails from './ReturnOrderItemDetails';
import { useDispatch, useSelector } from 'react-redux';
import ReturnOrderUpdateDetailsForm from './ReturnOrderUpdateDetailsForm';
import ReturnStoreOrderUpdateDetailsForm from './ReturnStoreOrderUpdateDetailsForm';
import { useState, useEffect, button } from 'react';
import { fetchHistoryList } from '../../../Queuess/action/action';
import ReactDrawer from 'react-drawer';
import {
  Col,
  Row,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Button
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import StatusBarReturnCustomer from '../../../Queuess/components/StatusBarReturnCustomer';
import StatusBarReturnStore from '../../../Queuess/components/StatusBarReturnStore';

function ReturnOrderDetails({ orderData, itemData }) {
  let stsBtn = 'bg-soft-dark text-dark';
  let LsSts = '';
  if (
    orderData?.Status === 'Pending' ||
    orderData?.Status === 'pending' ||
    orderData?.Status === 'Cancel Pending'
  ) {
    stsBtn = 'bg-soft-warning text-warning';
    LsSts = 'Pending';
  } else {
    LsSts = orderData?.Status;
  }
  if (orderData?.Status === 'Authorized') {
    stsBtn = 'bg-primary';
  } else if (
    orderData?.Status === 'Cancel' ||
    orderData?.Status === 'cancel' ||
    orderData?.Status === 'pending_payment'
  ) {
    stsBtn = 'bg-danger';
  } else if (orderData?.Status === 'Approved') {
    stsBtn = 'bg-success';
  }

  if (
    orderData?.Status === 'Rejected' ||
    orderData?.Status === 'rejected' ||
    orderData?.Status === 'Canceled' ||
    orderData?.Status === 'cancel'
  ) {
    LsSts = 'Canceled';
    stsBtn = 'bg-danger';
  }

  const [skudetail, setSkudetail] = useState('');
  const [orderValue, setorderValue] = useState('');
  const [detail, setDetail] = useState([]);
  const [buttonDetail, setButtonDetail] = useState('');
  const [open, setOpen] = useState(false);

  const toggleRightDrawer3 = async (historyData) => {
    let result = await fetchHistoryList({
      params: {
        queue_id: historyData.queue_id,
      },
    });

    //setOpen(true);
    if (historyData.queue_id !== '') {
      setorderValue(historyData);
      setDetail(result);
      //setCheck(result);
      setButtonDetail('3');
      setOpen(!open);
    }
  };

  return (
    <>
      <Card className="card-dh card-h-100">
        <CardBody className="card-body-dh">
          <Row>
            <Col className="ReturnInfo">Return Order Details :</Col>
            <Col>
              Ref# <strong>{orderData?.ReturnNo}</strong>
              {orderData?.ReturnDate ? (
                <span className="highlightInfo1">
                  Return Date : {orderData?.ReturnDate}
                </span>
              ) : null}
            </Col>
            <Col>
              Order Ref:{' '}
              <Link
                to={`/orders/${
                  orderData?.EntityId
                }/?order_mode=All&orderCn=${orderData?.ShippingDetails?.[0]?.Country.toLowerCase()}`}
                type="button"
                className="refColor"
              >
                {' '}
                <b> {orderData?.OrderId}</b>
              </Link>
              {orderData?.OrderDate ? (
                <span className="highlightInfo1">
                  Order Date : {orderData?.OrderDate}
                </span>
              ) : null}
            </Col>
            <Col>
              Shipment Ref:{' '}
              {Number(orderData?.ItemMode) === 2 ? (
                <a
                  href={`https://spade.danubehome.com/orders/detail/${orderData?.ShipmentInfo}`}
                  target="_blank"
                  rel="noreferrer"
                  className="refColor"
                >
                  {' '}<b>{orderData?.ShipmentInfo}</b>
                </a>
              ) : (
                <Link
                  to={`/orders/${orderData?.EntityId}/?order_mode=All&orderCn=${orderData?.ShippingDetails?.[0]?.Country.toLowerCase()}`}
                  type="button"
                  className="refColor"
                >
                  {' '}<b>{orderData?.ShipmentInfo}</b>
                </Link>
              )}
             
              {orderData?.DeliveryDate ? (
                <span className="highlightInfo1">
                  Delivery Date : {orderData?.DeliveryDate}
                </span>
              ) : null}
            </Col>
            <Col>
              {orderData?.CstNo ? (
                <span className="highlightInfo1">
                  CST No : {orderData?.CstNo}
                </span>
              ) : null}{' '}
            </Col>
          </Row>

          <Row className="mt-3">
            <Col xl={9} md={7}>
              {orderData?.type === 'store-return' ? (
                <ReturnStoreOrderDetailsBlock orderData={orderData} />
              ) : (
                // else block
                <ReturnOrderDetailsBlock orderData={orderData} />
              )}
            </Col>
            <Col xl={3} md={5}>
              {/*  <OrderInvoice orderData={orderData} /> */}
              {/*  <OrderUpdateDetailsForm orderData={orderData} /> */}
              {orderData?.type === 'store-return' ? (
                <ReturnStoreOrderUpdateDetailsForm orderData={orderData} />
              ) : (
                // else block
                <ReturnOrderUpdateDetailsForm orderData={orderData} />
              )}
            </Col>
          </Row>
          <Row>
            <Col xl={9} md={7}></Col>
            <Col xl={3} md={5} className="d-flex justify-content-end">
              <Button
                outline
                color="success"
                className="d-flex align-items-center gap-2"
                onClick={() => {
                  toggleRightDrawer3({
                    reference_no: orderData?.OrderNo,
                    date: '2024-06-24',
                    created_by: 'customer',
                    queue_id: orderData?.QueueId,
                    resolution_type: orderData?.Resolution,
                  });
                }}
                style={{ minWidth: '150px' }} // You can adjust the width as needed
              >
                Track Return Shipment
              </Button>
            </Col>
          </Row>

          <Row>
            <Col>
              {' '}
              <OrderItemDetails itemData={itemData} orderData={orderData} />
            </Col>
          </Row>

          <Row>
            <Col>
              <ReturnNotebyAdmin orderData={orderData} />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ReactDrawer open={open}>
        <Card className="card-h-100 OrderDetailsBox">
          <CardHeader>
            <Row>
              <Col className="textAlignRight">
                {' '}
                <button
                  type="button"
                  className="btn-close "
                  aria-label="Close"
                ></button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <p>
              <b>Return status Tracking{orderData?.StoreCode}</b>
            </p>
            {orderData?.StoreCode != null ? (
              <StatusBarReturnStore
                detail={detail}
                orderValue={orderValue}
                deliveryMethod={orderData?.Delivery_method}
                resolution_type={orderData?.QueueResolution}
                deliveryLocation={orderData?.Delivery_location}
              />
            ) : (
              <StatusBarReturnCustomer
                detail={detail}
                orderValue={orderValue}
              />
            )}
            {/* Add StatusBar component */}
          </CardBody>
        </Card>
      </ReactDrawer>
    </>
  );
}

export default ReturnOrderDetails;
